<template>
  <div>

    <b-row style="margin-top: 2em">
      <b-col>
        <h5 class="text-info m-1">{{ $t("globals.contract_details") }}:</h5>
      </b-col>
      <b-col>
        <b-btn size="sm" class="m-1 float-right" variant="info" v-if="!edit" @click="edit = true">
          {{ $t("globals.edit") }}
        </b-btn>
        <b-btn size="sm" variant="warning" class="float-right m-1" v-if="edit" @click="cancelEdit">
          {{ $t("globals.cancel") }}
        </b-btn>
      </b-col>
    </b-row>

    <b-row style="margin-top: 2em" v-if="!isthereContractDetail">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              {{ $t("globals.contract_type") }}:
              <b-form-select v-model="new_details.contract_type"
                :options="contractDetailsSet['contract_types']"></b-form-select>
            </b-col>
            <b-col>
              {{ $t("globals.start_date") }}:
              <b-form-datepicker id="start_date-datepicker" v-model="new_details.start_date" class="mb-2"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }"></b-form-datepicker>
            </b-col>
            <b-col>
              {{ $t("globals.contract_duration") }}: 
              <b-form-select v-model="new_details.duration" :options="contractDetailsSet['durations']"></b-form-select>
            </b-col>
            <b-col>
              {{ $t("globals.contract_termination_policy") }}:
              <b-form-select v-model="new_details.termination_policy"
                :options="contractDetailsSet['termination_policies']"></b-form-select>
              <b-btn size="sm" variant="success" class="float-right m-1" @click="create_details(new_details)"
                :disabled="!can_create">
                {{ $t("globals.save") }}
              </b-btn>
            </b-col>
          </b-row>
          <span class="small" v-if="data_from_first_order">
            *Information from first order
          </span>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 2em" v-else>
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              {{ $t("globals.contract_type") }}:
              <b-form-select v-model="contract_details.contract_type" :options="contractDetailsSet['contract_types']"
                :disabled="!edit"></b-form-select>
            </b-col>
            <b-col>
              {{ $t("globals.start_date") }}:
              <b-form-datepicker id="start_date-datepicker" v-model="contract_details.start_date" class="mb-2"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }" :disabled="!edit"></b-form-datepicker>
            </b-col>
            <b-col>
              {{ $t("globals.contract_duration") }}: 
              <b-form-select v-model="contract_details.duration" :options="contractDetailsSet['durations']"
                :disabled="!edit"></b-form-select>
            </b-col>
            <b-col>
              {{ $t("globals.contract_termination_policy") }}:
              <b-form-select v-model="contract_details.termination_policy"
                :options="contractDetailsSet['termination_policies']" :disabled="!edit"></b-form-select>
              <b-btn size="sm" variant="success" class="float-right m-1" v-if="edit"
                @click="save_detail(contract_details)">
                {{ $t("globals.save") }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 2em">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              <h5 class="text-info ">{{ $t("globals.price_list") }}:</h5>
            </b-col>
          </b-row>
          <b-row>
            <ulu-customer-items :price_list="price_list" :editable="edit"
              :id="contract_details_present ? contract_details.id : 0" :refresh="refresh" />
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 2em">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              <h5 class="text-info m-1">{{ $t("globals.notes") }}:</h5>
            </b-col>
            <b-col>
              <b-btn size="sm" variant="success" class="float-right m-1" v-if="edit" @click="save">
                {{ $t("globals.save") }}
              </b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-textarea v-model="notes" rows="20" :disabled="!edit">
              </b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 2em">
      <!-- First order -->
      <b-col>
        <h1 class="text-info m-1">{{ $t("globals.first_order") }}:</h1>
        <b-card bg-variant="light">
          <ulu-order></ulu-order>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "ulu-customer-items": () => import("@/components/customers/customer/CustomerContractDetailsPricelist"),
    "ulu-order": () => import("@/components/orders/order/Order")
  },
  props: {
    notes: String,
    refresh: Function,
    contract_details: {
      type: Object,
      default: () => ({})
    },
    first_order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      edit: false,

      new_details: {
        contract_type: "",
        start_date: "",
        duration: "",
        termination_policy: ""
      },
      data_from_first_order: false
    };
  },
  methods: {
    ...mapActions(["fetchContracDetailsSets", "fecthCustomerOrdersItems"]),
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),


    cancelEdit() {
      this.edit = false;
      this.refresh();
    },
    save() {
      let data = {
        query: `
          mutation CustomerUpdateNotes($customer_id: ID!, $new_notes: String!) {
            res: CustomerUpdateNotes (customer_id: $customer_id, new_notes: $new_notes)
          }
        `,
        variables: {
          customer_id: parseInt(this.$route.params.id),
          new_notes: this.notes
        }
      };
      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelEdit();
      });
    },
    save_detail(detail) {
      let data = {
        query: `
        mutation {
          res:
            CustomerContractDetailsEdit(
                id:${detail.id},
                contract_type: "${detail.contract_type}",
                start_date: "${detail.start_date}",
                duration: "${detail.duration}",
                termination_policy: "${detail.termination_policy}"
              )
            }
        `
      };
      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelEdit();
      });
    },
    create_details() {
      let data = {
        query: `
        mutation {
          res:
            CustomerContractDetailsCreate(
                customer_id:${parseInt(this.$route.params.id)},
                contract_type: "${this.new_details.contract_type}",
                start_date: "${this.new_details.start_date}",
                duration: "${this.new_details.duration}",
                termination_policy: "${this.new_details.termination_policy}"
              )
            }
        `
      };
      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelEdit();
      });
    },
    setDetailsFromFirstOrder() {
      if (Object.keys(this.first_order).length > 0) {
        this.data_from_first_order = true;
        this.new_details.start_date = this.first_order.contract_start_on;
        this.new_details.duration = this.first_order.contract_duration;
        this.new_details.termination_policy = this.first_order.payment_term_name;
        this.new_details.contract_type = this.first_order.order_type;
      }
    }
  },
  created() {
    this.fetchContracDetailsSets();
    if (!this.isthereContractDetail) {
      this.setDetailsFromFirstOrder();
    }
    this.fecthCustomerOrdersItems(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["getContractDetailsSet", "getCustomerOrdersItems"]),
    contractDetailsSet() {
      return this.getContractDetailsSet;
    },
    isthereContractDetail() {
      return this.contract_details != null;
    },
    can_create() {
      return this.new_details.contract_type != "" && this.new_details.start_date != "" && this.new_details.duration != "" && this.new_details.termination_policy != "";
    },
    contract_details_present() {
      return this.contract_details != null && Object.keys(this.contract_details).length > 0;
    },
    price_list() {
      if (this.contract_details && this.contract_details.contract_detail_items && this.getCustomerOrdersItems) {

        const contract_detail_items = this.contract_details.contract_detail_items
        const customer_orders_items = this.getCustomerOrdersItems

        customer_orders_items.forEach(new_item => {
          const found = contract_detail_items.some(item => item.name === new_item.item_name);
          if (!found) {
            contract_detail_items.push({
              id: null,
              price_one_time: new_item.price_one_time,
              price_per_month: new_item.price_per_month,
              name: new_item.item_name,
              item_type: new_item.item_type
            });
          }
        });

        return contract_detail_items;
      }
      else {
        const contract_detail_items = this.getCustomerOrdersItems.map(item => {
          return {
            id: null,
            price_one_time: item.price_one_time,
            price_per_month: item.price_per_month,
            name: item.item_name,
            item_type: item.item_type
          };
        });
        return contract_detail_items
      }

    }

  }
};
</script>
